// side effect: fetch new shortArticleNumber calculation when decisions are made
import {fetchShortNumber} from '../slices/shortNumberSlice';

import {
	setMode,
} from '../slices/statusSlice';
import {setProductModel} from '../slices/configurationSlice';
import {selectUnsatisfied} from '../selectors';

export const shortArticleNumberMiddleware = store => next => async action => {
	const result = next(action);

	// skip when feature is off
	const currentDecisions = store.getState().decisions.data;
	if (store.getState().status.features.shortArticleNumber !== true) return result;

	const isSatisfied = selectUnsatisfied(store.getState())?.length === 0 || false;

	if (
		store.getState().shortNumber.status !== 'loading' && action.type === 'configuration/store/fulfilled'
	) {
		// after decision(s), get the new shortArticleNumbers, when model is satisfied
		if (store.getState().configuration.data.projects[0].project?.productModelId && isSatisfied) {
			store.dispatch(fetchShortNumber({
				prefixLevels: ['ProductModel', store.getState().configuration.data.projects[0].project.productModelId],
				data: JSON.stringify(
					{
						configurationData: {
							decisions: getFilteredDecisions(currentDecisions.decisions)
						}
					}
				)
			}));
		}

		const base = store.getState().lightProfile.data.project?.base;
		const zone = store.getState().lightProfile.data.project?.zone;

		// get the new shortArticleNumbers, when lightProfile is selected
		if (base && zone) {
			store.dispatch(fetchShortNumber({
				prefixLevels: ['CircularProfile', base.replace('DynamicAmbiance', 'DynamicAmbience'), zone],
				data: JSON.stringify(
					{
						configurationData: {
							lightProfileData: {
								base: store.getState().lightProfile.data.project.base,
								zone: store.getState().lightProfile.data.project.base,
								latitude: store.getState().lightProfile.data.project.location.latitude,
								longitude: store.getState().lightProfile.data.project.location.longitude,
								locationName: store.getState().lightProfile.data.project.location.name,
								timezoneName: store.getState().lightProfile.data.project.location.timezoneName,
							}
						}
					}
				)
			}));
		}

		if (store.getState().configuration.data.projects[0].project?.dimmLevelData) {
			store.dispatch(fetchShortNumber({
				prefixLevels: ['BasicDimmingID'],
				data: JSON.stringify(
					{
						configurationData: {
							dimmLevel: store.getState().configuration.data.projects[0].project?.dimmLevelData
						}
					}
				)
			}));
		}
	}

	if (
		action.type === 'shortNumber/loadConfigByShortNumberLoading/fulfilled'
	) {
		const loadedPrefixLevels = store.getState().shortNumber.data.prefixLevels;
		// find the next item after 'ProductModel' in the array loadedPrefixLevels
		let model = '';
		if (loadedPrefixLevels && loadedPrefixLevels.indexOf('ProductModel') !== -1) {
			model = loadedPrefixLevels[loadedPrefixLevels.indexOf('ProductModel') + 1];
		} else {
			model = store.getState().configuration.data.projects[0].project.productModelId;
		}
		await store.dispatch(setProductModel(
			{
				productModel: model
			}
		));
		const loadedDecisions = store.getState().shortNumber.data.loadedConfig?.configurationData.decisions;
		if (loadedDecisions) {
			await store.dispatch(setMode({mode: store.getState().status.mode ?? 'external'}));
		}
	}
	return result;
};
// reduce decisions to minimal set t be stored
// only features, that contain decisions and featureValues that are not undefined
function getFilteredDecisions(decs) {
	return decs
		.filter(dec => dec.featureValues.find(fv => fv.state === 'Included' && (fv.kind === 'Explicit' || fv.kind === 'Implicit')))
		.map(dec => (
				{
					variableId: dec.variableId,
					featureValue: dec.featureValues.filter(fv => fv.state === 'Included' && (fv.kind === 'Explicit' || fv.kind === 'Implicit')).map(fv => fv.featureValueId).join(';'),
				}
			)
		)
		.sort((a, b) => {
			if (a.variableId < b.variableId) {
				return -1;
			}
			if (a.variableId > b.variableId) {
				return 1;
			}
			return 0;
		});
}
